<script>
    import { Link } from 'svelte-navigator'
    import { menuVisible } from '../../stores';

    let visible;

    menuVisible.subscribe(value => {
        visible = value;
    })

    const handleClick = () => {
        menuVisible.update(value => !value)
    };

    const fetchData = (async () => {
		const endpoint = 'navigation/render/1'
		const response = await fetch(`https://strapi.globalshipping.watch/${endpoint}`)
		if (response.ok) {
			return response.json()
		} else {
			throw new Error(error)
		}
	})();
</script>

<!-- Begin of top menu -->
<nav class="top-menu-links { visible ? 'menu-visible' : '' }">
    <ul class="links">
        {#await fetchData}

        {:then data}
            {#each data as nav}
                <li>
                    {#if nav.type === 'INTERNAL'}
                        <Link to={nav.path} on:click={handleClick}>{nav.title}</Link>
                    {:else if nav.type === 'EXTERNAL'}
                        {#if nav.parent !== null}
                            <a href={nav.externalPath} on:click={handleClick}>{nav.title}</a>
                        {:else}
                            <a href={nav.externalPath} target="_blank" on:click={handleClick}>{nav.title}</a>
                        {/if}
                    {/if}
                </li>
            {/each}
        {:catch error}
            <p>{error}</p>
        {/await}
    </ul>
</nav>